import React from "react";
import { Pagination } from "zina-dogi-react";
import { utils, ToggleSwitch, AlertTypeBadge } from "~/utils";
import { ALERT_TYPES } from "~/utils/components/alert_type_badge";
import "./notification_table.scss";

const titles = [
    "Type",
    "Title",
    "Message",
    "Active",
    "Start Date",
    "End Date",
    "Created At",
    "Created By",
    "Updated By",
    "Actions"
];

const NotificationTable = ({ list, pagination, updatingIds = {}, onToggleActive = () => {}, onEdit = () => {}, onCopy = () => {}, ...props }) => {
    const { className } = props;
    const notificationTable_op = {
        className: ["notification_table", className].join(" ")
    };
    return (
        <div {...notificationTable_op}>
            <nav className="navbar">
                <span className="navbar-brand h4" />
                <div className="controls">
                </div>
            </nav>
            <br />
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`notification_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(list, pagination.actualPage, updatingIds, onToggleActive, onEdit, onCopy)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = (list, page, updatingIds, onToggleActive, onEdit, onCopy) => {
    const values = Array.isArray(list) ? list : Object.values(list);
    if (values.length > 0) {
        return values.map((notification, i) => {
            const notification_id = notification.id || `p${page}_i${i}`;
            const type = notification.type || notification.level || ALERT_TYPES.danger;
            const isUpdating = Boolean(updatingIds[notification.id]);
            const creator =
                (notification.created_by && (notification.created_by.username || notification.created_by.name)) ||
                notification.created_by ||
                "-";
            const updater =
                (notification.updated_by && (notification.updated_by.username || notification.updated_by.name)) ||
                notification.updated_by ||
                "-";

            return (
                <tr key={`notification_${notification_id}`} style={{ textAlign: "center" }}>
                    <td>
                        <AlertTypeBadge type={type} />
                    </td>
                    <td>{notification.title || notification.activity_name || "-"}</td>
                    <td style={{ textAlign: "left" }}>
                        <div className="notification_table__message-cell" title={notification.message}>
                            {notification.message || "-"}
                        </div>
                    </td>
                    <td>
                        <ToggleSwitch
                            checked={Boolean(notification.is_active)}
                            loading={isUpdating}
                            disabled={!notification.id}
                            onChange={() => onToggleActive(notification.id, notification.is_active)}
                            ariaLabel={notification.is_active ? "Deactivate alert" : "Activate alert"}
                            sizeVariant="md"
                        />
                    </td>
                    <td>{notification.start_date ? utils.renderDate(notification.start_date) : "-"}</td>
                    <td>{notification.end_date ? utils.renderDate(notification.end_date) : "-"}</td>
                    <td>{notification.created_at ? utils.renderDate(notification.created_at) : "-"}</td>
                    <td>{creator}</td>
                    <td>{updater}</td>
                    <td>
                        <button
                            className="btn btn-sm btn-primary"
                            title="Edit"
                            onClick={() => onEdit(notification)}
                        >
                            <i className="fas fa-pencil-alt" style={{ color: "#fff" }} aria-hidden="true" />
                        </button>
                        {" "}
                        <button
                            className="btn btn-sm btn-primary"
                            title="Copy"
                            onClick={() => onCopy(notification)}
                        >
                            <i className="fas fa-copy" style={{ color: "#fff" }} aria-hidden="true" />
                        </button>
                    </td>
                </tr>
            );
        });
    }

    return (
        <tr>
            <td colSpan={titles.length}>No data found</td>
        </tr>
    );
};

export default NotificationTable;
